import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import CredentialsClient from 'rest/CredentialsClient';
import { errorAction } from 'components/utility/actions';
import * as restartActions from 'components/widgets/Restart/actions';
import * as actions from './actions';

const credentialsClient = new CredentialsClient();

export function doFetchCredentials() {
	return credentialsClient.getAll().then(
		(response) => response.data
	);
}

/**
 * Counts the number of credentials in each status group.
 *
 * Grouping is based on the required actions for each credential.
 *
 * Available groups:
 *   error - The number of credentials with errors.
 *   warning - The number of credentials that need attention.
 *   ok - The number of credentials that are 'ready'.
 *
 * @param {Object} credentials The credentials data.
 *
 * @returns {Object} The credentials count for each of the groups - 'error', 'warning' and 'ok'.
 */
export function getAllCredentialsCounts(credentials) {
	let credentialsCounts = {
		error: 0,
		warning: 0,
		ok: 0
	};

	Object.values(credentials).forEach(cred => {
		credentialsCounts[cred.status.action_status] += 1;
	});

	return credentialsCounts;
}

export function *fetchCredentials(action) {
	try {
		const credentials = yield call(doFetchCredentials);
		yield put({ type: actions.FETCH_CREDENTIALS_SUCCESS, payload: credentials });
	} catch (error) {
		yield put(errorAction(actions.FETCH_CREDENTIALS_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.FETCH_CREDENTIALS, fetchCredentials);
	yield fork(takeLatest, restartActions.AWAIT_RESTART_SUCCESS, fetchCredentials);
}
